import { makeStyles, tokens} from '@fluentui/react-components';
import { WorkItemTransitionErrorType, WorkItemTransitionTriggerType } from '../types';
import { useAutomationRuleTrigger } from '../use-trigger';
import FromValueInput from './from-value-input';
import ToValueInput from './to-value-input';

interface Props {
  data: WorkItemTransitionTriggerType;
  validations: WorkItemTransitionErrorType | null
}

export default function WorkItemTransitionsForm(props: Props) {
	const classes = useStyles();
	const {resetValidations} = useAutomationRuleTrigger();

	return (
		<div className={classes.root}>
			<div className={classes.columnFlex}>
				<FromValueInput
					resetValidations={resetValidations}
					validations={props.validations?.from || null}
					data={props.data}
				/>
			</div>
			<div className={classes.columnFlex}>
				<ToValueInput
					resetValidations={resetValidations}
					validations={props.validations?.to || null}
					data={props.data}
				/>
			</div>
		</div>
	);
}

export const useStyles = makeStyles({
	root: {
		width: '50%',
		display: 'flex',
		gap: '12px',
	},
	columnFlex: {
		flex: '1 1 0px',
	},
	dropdown: {
		minWidth: '120px',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		'::after': {
			borderBottom: 'none'
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':active': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		}
	}
});